import React, { useState, useEffect, useCallback } from 'react';
import { List, Button, Dimmer } from 'semantic-ui-react';
import { useSelector, useDispatch } from 'react-redux';
import { subscriptionActions } from '../../actions';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import '../../utils';
import { useDropzone } from 'react-dropzone';
import './ColorExtractor.css';

const ColorExtractor = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const language = localStorage.getItem('language') || 'rtl/fa-IR';

  useEffect(() => {
    const currency = language === 'rtl/fa-IR' ? 'IRR' : 'EUR';
    dispatch(subscriptionActions.getListOfSubscriptions(currency));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [loadedImage, setLoadedImage] = useState();

  const onDrop = useCallback(acceptedFiles => {
    console.log(acceptedFiles);
    acceptedFiles.forEach(file => {
      const reader = new FileReader();
      const url = reader.readAsDataURL(acceptedFiles[0]);
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onloadend = () => {
        // Do whatever you want with the file contents
        const binaryStr = reader.result;
        console.log(binaryStr);
        setLoadedImage(binaryStr);
        setTimeout(() => {
          imageColors(binaryStr);
        }, 500);
      };
      // reader.readAsArrayBuffer(file);
    });
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const imageColors = url => {
    const getColors = require('get-image-colors');
    document.getElementById('colorsPalate').innerHTML =
      '<div class="cExtCenter"><div class="wave"></div><div class="wave"></div><div class="wave"></div><div class="wave"></div><div class="wave"></div><div class="wave"></div><div class="wave"></div><div class="wave"></div><div class="wave"></div><div class="wave"></div></div>';
    // return;
    getColors(`${url}`).then(colors => {
      document.getElementById('colorsPalate').innerHTML = '';
      const imageColors = [];
      let oldColor = '';
      colors.map(color => {
        if (color.hex() !== oldColor) {
          imageColors.push(color.hex());
          const rgb = color._rgb;
          console.log('rgb  ', rgb);
          const brightness = Math.round(
            (parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) / 1000,
          );
          const textColor = brightness > 125 ? 'black' : 'white';
          document.getElementById('colorsPalate').innerHTML +=
            '<span class="colorBox" style="background-color:' +
            color +
            '; color: ' +
            textColor +
            '">' +
            color +
            '</span>';
        }
        oldColor = color.hex();
      });
      console.log(imageColors);
    });
  };

  const loadDefault = () => {
    const samples = [
      "antnmug.jpg",
      "crtymdcrf.jpg",
      "drsgrlssbp.jpg",
      "ftywithhh.JPG",
      "sammanns.jpg",
      "shoesinyew.jpg",
      "smbuuwarrrsthe.jpg",
      "VB-Landscape-P-0565.jpg",
      "VB-Landscape-P-0576.jpg",
      "weetrqbtfr.jpg"
    ]
    const random = Math.floor(Math.random() * samples.length);
    const sampleImage = samples[random];
    imageColors(`./assets/images/extractorSamples/${sampleImage}`);
    setLoadedImage(`./assets/images/extractorSamples/${sampleImage}`);
  }

  return (
    <div className="section cExt">
      <div className="boxContent">
        <div className="title">{t('contents:imageExtractColorTitle')}</div>
        <div className="text">{t('contents:imageExtractColorParagraph')}</div>
        <div className="btnHolder">
          <button {...getRootProps()} className="primary button vButton colorPrimary">{t('contents:imageExtractUpload')}</button>
          <button className="button vButton outlinePrimary rightSpace" onClick={() => loadDefault()}>{t('contents:imageExtractSample')}</button>
        </div>
      </div>
      <div className="extHolder">
        <div id="cExt" className="alone">
          <div className="extractorBox" {...getRootProps()}>
            <input {...getInputProps()} />
            {isDragActive ? (
              <p>{t('contents:imageExtractDropHere')}</p>
            ) : loadedImage ? (
              <img className="cExtLoadedImage" src={loadedImage} />
            ) : (
              <p>{t('contents:imageExtractDropBoxText')}</p>
            )}
          </div>
          <div id="colorsPalate" className="colorsPalate"></div>
        </div>
      </div>
    </div>
  );
};

export default ColorExtractor;
